import React from 'react';

import NavLinkBase from './NavLink';

const navLink = props => {
  return <NavLinkBase {...props} />;
};

export default navLink;
